import { useState, useEffect } from "react";
import styles from "./referralhistories.module.css";
import { Chip } from "@mui/material";
import axios from "axios";
import { authData } from "../../../admin/components/GetAuth";
import Loader from "../../../admin/components/Loader";
import SideBar from "../../components/sideBar";
import { TableLoader } from "../../components/ContentLoader";
import TablePaginationComponent from "../../../admin/components/TablePagination";

const ReferralHistories = () => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [referrals, setReferrals] = useState([]);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  }

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/customer/referral-histories", {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setContentLoading(false);
      if (response.data.status === "SUCCESS") {
        setReferrals(response?.data.data);
      }
    }).catch((error) => {
      setContentLoading(false);
    });
  }, [auth?.api_token]);

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />

    <div className={`${styles.MainDivCustomer}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerSideBar}`}><SideBar /></div>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              <div className={`${styles.UserHead}`}>
                <p className={`${styles.UserProName}`}>Referral Histories</p>
              </div>


              {contentLoading && <TableLoader />}

              {!contentLoading && <div className={`${styles.BookingCard}`}>


                {referrals?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((item, index) => {
                  return (<div className={`${styles.BookingCardUnderTop}`}>
                    <div className={`${styles.MyBookConHead}`}>
                      <p className={`${styles.BookingCarDeTitle}`}>
                        {item?.referred_user_name}
                        {parseInt(item?.status) === 0 && <Chip label="Pending" variant="outlined" style={{ fontWeight: "600", backgroundColor: "#FFFFFF", borderColor: "#8C8C8C", color: "#8C8C8C", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                        {parseInt(item?.status) === 1 && <Chip label="Confirmed" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgba(121, 186, 247, 0.3)", borderColor: "rgb(8, 56, 161)", color: "rgb(8, 56, 161)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                        {parseInt(item?.status) === 2 && <Chip label="Redeemed" variant="outlined" style={{ fontWeight: "600", backgroundColor: "rgb(208, 247, 217)", borderColor: "rgb(2, 87, 40)", color: "rgb(2, 87, 40)", marginLeft: '10px', height: '26px', borderRadius: '12px' }} />}
                      </p>

                    </div>

                    <div className={`${styles.MyBookConDeSec}`}>
                      <p className={`${styles.BookingCarDeSTitle}`}>
                        <span>Amount:</span>{" "}
                        £{parseFloat(item?.amount).toFixed(2)}
                      </p>
                      <p className={`${styles.BookingCarDeSTitle}`}>
                        <span>Used Amount:</span>{" "}
                        £{parseFloat(item?.used_amount).toFixed(2)}
                      </p>
                    </div>
                  </div>);
                })}

                {referrals?.length > 0 && (<TablePaginationComponent
                  count={referrals?.length}
                  colSpan={6}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={paginationChangePage}
                  handleChangeRowsPerPage={paginationChangeRowsPerPage}
                />)}

                {referrals?.length === 0 && (<div className={`${styles.NofileSec}`}>
                  <div className={`${styles.NofileSecUnder}`}>
                    <img src="/images/no-connection.png" alt="" />
                    <p>No referrals are available now</p>
                  </div>
                </div>)}

              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>);
};

export default ReferralHistories;